import { render, staticRenderFns } from "./professionals_info.vue?vue&type=template&id=44f7eb23&scoped=true"
import script from "./professionals_info.vue?vue&type=script&lang=js"
export * from "./professionals_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f7eb23",
  null
  
)

export default component.exports